import React from "react";
import { useInView } from "react-intersection-observer";

import Button from "../../Button/Button";

// css
import * as styles from "./StartJourney.module.css";

const StartJourneyComponent = ({ onCtaClick }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  // Handle CTA click
  const handleCtaClick = e => {
    if (onCtaClick) {
      onCtaClick(e);
    }
  };

  return (
    <section className={styles.featuredWrapper}>
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"}`}
      >
        <div className="row">
          <div className="col-12 text-center">
            <div className={styles.startJourney_content}>
              <h1>Start Your Metabolic Health Journey</h1>
              <p>
                Begin a personalised metabolic health program designed to
                improve metabolism, achieve metabolic balance, and support
                long-term remission and stability.
              </p>
              <div className={styles.ctaSection}>
                <Button
                  text="Start Your Metabolic Plan"
                  href="/contact"
                  variant="primary"
                  onClick={handleCtaClick}
                  btnClass={styles.ctaBtn}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartJourneyComponent;
